module.exports = __webpack_public_path__ + "img/trends_3.5be010a0.jpg";